import { gql } from '@apollo/client';

const UPDATE_SITEUSER_PAYMENTLIABILITY = gql`mutation updateSiteUserPaymentLiability($input:SiteUserPaymentLiabilityInput)
{
	siteUserContext{
		updateSiteUserPaymentLiability(input:$input)
		{
			message
			siteUser
			{
				avatar
				companyName
				email
				id
				isCurrentUser
				lastLoggedIn
				name
				siteId
				siteRoleId
				status
				sufficentSubscriptionLevel
				telephone				
			}
			success
		}
	}
}`;

export default UPDATE_SITEUSER_PAYMENTLIABILITY;